import "@hotwired/turbo-rails";
import "./controllers";

document.addEventListener("turbo:load", ({ detail: { url } }) => {
  const selectAll = document.getElementById("select-all");
  if (selectAll) {
    const checkboxes = selectAll.form.querySelectorAll("input[type=checkbox]");
    selectAll.addEventListener("input", ({ target }) => {
      for (const element of checkboxes) {
        const checkbox = element;
        checkbox.checked = target.checked;
      }
    });
  }

  if (window.gtag) {
    window.gtag("config", "G-LMNS817NJK", { page_location: url });
  }

  for (const el of document.querySelectorAll("[data-action]")) {
    el.addEventListener("click", (event) => {
      if (window.gtag) {
        event.preventDefault();
        const {
          target: {
            dataset: { action, category, label, value },
          },
        } = event;

        window.gtag("event", action, {
          event_category: category,
          event_label: label,
          value,
        });

        setTimeout(() => {
          window.location = el.href;
        }, 500);
      }
    });
  }
});
